import { WorkflowState } from "common-util-experience-client";
import { createWorkflowApi } from "../api-helpers/CommonUtilsApiHelper";
import { GridDropdown } from "./GridDropdown";
import { WorkflowConstants, WorkflowStateConstants } from "../helper/WorkflowConstants";
import { Constants } from "../constants/Lookups";

export interface Props {
  label: string;
  type: string;
  onChange: (selection: WorkflowState[]) => void;
  initialStatusIds?: string[];
}

export const GridWorkflowStatusDropdown = ({ label, type, onChange, initialStatusIds}: Props) => {
  const workflowApi = createWorkflowApi();

  const loadData = async (): Promise<WorkflowState[]> => {
    if (!type) {
      return [];
    }
    
    const { data } = await workflowApi.workflowControllerGetStatesForWorkflow(type);

    if(type === WorkflowConstants.pathway){
      data.push({
        stateId: Constants.NOT_SET.toLowerCase(),
        stateName: Constants.NOT_SET
      } as WorkflowState)
    }
    if(type === WorkflowConstants.eligibility){
      data.push({
        stateId: Constants.NULL.toLowerCase(),
        stateName: Constants.NULL
      } as WorkflowState)
    }

    return data;
  };

  return (
    <GridDropdown
      label={label}
      keyProvider={state => state.stateId}
      labelProvider={state => state.stateName}
      dataProvider={loadData}
      initialKeys={initialStatusIds}
      onChange={onChange}
      ></GridDropdown>
  );
};
